import React from 'react';
import { Smartphone, ExternalLink } from 'lucide-react';

const apps = [
    {
        title: 'MultiSellerPro',
        tagline: 'The only app with live data across every platform.',
        description:
            'Profit calculators, image/barcode scans, and stock checker for Amazon, Walmart & eBay!',
        emoji: '📦',
        appStoreLink: 'https://apps.apple.com/us/app/msp-scanner/id6761768601',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.multisellerpro.app.twa',
        color: 'from-teal-500 to-blue-600',
        bg: 'bg-teal-50',
        border: 'border-teal-200',
        badgeBg: 'bg-teal-100',
        badgeText: 'text-teal-800',
        tags: ['Amazon', 'Walmart', 'eBay', 'Profit Calculator', 'Stock Checker'],
    },
    {
        title: 'Multi Influencer Pro',
        tagline: 'The only AIP mobile app.',
        description:
            'The first and only mobile app built for Amazon Influencer Program creators.',
        emoji: '🎬',
        appStoreLink: 'https://apps.apple.com/us/app/msp-scanner/id6761768601',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.multisellerpro.app.twa',
        color: 'from-purple-500 to-pink-600',
        bg: 'bg-purple-50',
        border: 'border-purple-200',
        badgeBg: 'bg-purple-100',
        badgeText: 'text-purple-800',
        tags: ['AIP', 'Creator Connections', 'Video Studio', 'Thumbnail Maker'],
    },
];

const MobileAppPage = ({ user }) => {
    return (
        <div className="max-w-2xl mx-auto py-12 px-6">

            <div className="mb-10">
                <div className="flex items-center gap-2 mb-2">
                    <Smartphone size={22} className="text-teal-600" />
                    <h1 className="text-3xl font-bold text-gray-800">Download Our Mobile Apps</h1>
                </div>
                <p className="text-gray-500">
                    Everything you need to run and grow your business - in your pocket.
                </p>
            </div>

            <div className="flex flex-col gap-6">
                {apps.map((app) => (
                    <div
                        key={app.title}
                        className={`bg-white rounded-2xl shadow-lg border ${app.border} overflow-hidden`}
                    >
                        {/* Top color bar */}
                        <div className={`h-2 bg-gradient-to-r ${app.color}`} />

                        <div className="p-6">
                            {/* Header */}
                            <div className="flex items-start gap-4 mb-4">
                                <div
                                    className={`w-14 h-14 rounded-2xl ${app.bg} flex items-center justify-center text-3xl flex-shrink-0`}
                                >
                                    {app.emoji}
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2 flex-wrap mb-1">
                                        <h2 className="text-xl font-bold text-gray-800">{app.title}</h2>
                                        <span
                                            className={`text-xs font-semibold px-2 py-0.5 rounded-full ${app.badgeBg} ${app.badgeText}`}
                                        >
                                            {app.tagline}
                                        </span>
                                    </div>
                                    <p className="text-gray-500 text-sm leading-relaxed">{app.description}</p>
                                </div>
                            </div>

                            {/* Feature tags */}
                            <div className="flex flex-wrap gap-2 mb-5">
                                {app.tags.map((tag) => (
                                    <span
                                        key={tag}
                                        className="text-xs text-gray-500 bg-gray-100 border border-gray-200 rounded-full px-3 py-1"
                                    >
                                        {tag}
                                    </span>
                                ))}
                            </div>

                            {/* Download buttons */}
                            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
                                <a
                                    href={app.appStoreLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-block hover:opacity-80 transition"
                                >
                                    <img
                                        src="/appstore.png"
                                        alt="Download on the App Store"
                                        className="h-12 w-auto object-contain"
                                    />
                                </a>
                                <a
                                    href={app.playStoreLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-block hover:opacity-80 transition"
                                >
                                    <img
                                        src="/playstore.png"
                                        alt="Get it on Google Play"
                                        className="h-12 w-auto object-contain"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <p className="text-center text-xs text-gray-400 mt-8">
                Available for iOS & Android
            </p>
        </div>
    );
};

export default MobileAppPage;